import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ActivePromotionCard = ({ promotion, onRemove }) => {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);

  const getDaysRemaining = (validUntil) => {
    const today = new Date();
    const endDate = new Date(validUntil);
    const diffTime = endDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const daysRemaining = getDaysRemaining(promotion?.validUntil);
  const isExpiringSoon = daysRemaining <= 7;

  return (
    <div className="bg-card rounded-xl border border-border shadow-warm overflow-hidden">
      <div className="relative h-32 md:h-40 overflow-hidden">
        <Image
          src={promotion?.image}
          alt={promotion?.imageAlt}
          className="w-full h-full object-cover"
        />
        <div className="absolute top-3 left-3">
          <div className="bg-accent text-accent-foreground px-3 py-1.5 rounded-full font-caption text-xs font-semibold">
            {promotion?.discount}
          </div>
        </div>
        <div className="absolute top-3 right-3">
          <button
            onClick={onRemove}
            className="w-9 h-9 rounded-full bg-background/90 backdrop-blur-sm flex items-center justify-center transition-smooth hover:bg-destructive hover:text-destructive-foreground focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3"
            aria-label="Rimuovi promozione"
          >
            <Icon name="X" size={18} />
          </button>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-start justify-between gap-3 mb-3">
          <div className="flex-1 min-w-0">
            <h3 className="font-heading text-base md:text-lg font-semibold text-foreground mb-1 line-clamp-2">
              {promotion?.title}
            </h3>
            <p className="font-body text-sm text-muted-foreground line-clamp-1">
              {promotion?.storeName}
            </p>
          </div>
        </div>

        <div className={`mb-4 p-3 rounded-lg border ${isExpiringSoon ? 'bg-warning/10 border-warning/30' : 'bg-muted/50 border-border'}`}>
          <div className="flex items-center gap-2 mb-1">
            <Icon 
              name={isExpiringSoon ? "AlertCircle" : "Calendar"} 
              size={16} 
              color={isExpiringSoon ? "var(--color-warning)" : "var(--color-muted-foreground)"} 
            />
            <p className="font-caption text-xs text-muted-foreground">
              Valida fino al {new Date(promotion.validUntil)?.toLocaleDateString('it-IT')}
            </p>
          </div>
          <p className={`font-body text-sm font-medium ${isExpiringSoon ? 'text-warning-foreground' : 'text-foreground'}`}>
            {daysRemaining > 0 
              ? `${daysRemaining} ${daysRemaining === 1 ? 'giorno rimanente' : 'giorni rimanenti'}`
              : 'Scade oggi'}
          </p>
        </div>

        {isExpanded && (
          <div className="mb-4 p-3 bg-muted/50 rounded-lg">
            <p className="font-caption text-sm text-muted-foreground mb-2">Come usare:</p>
            <p className="font-body text-sm text-foreground whitespace-pre-line">
              {promotion?.instructions}
            </p>
          </div>
        )}

        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            fullWidth
            iconName={isExpanded ? "ChevronUp" : "ChevronDown"}
            iconPosition="right"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? 'Nascondi' : 'Dettagli'}
          </Button>
          <Button
            variant="default"
            size="sm"
            iconName="ExternalLink"
            iconPosition="right"
            onClick={() => navigate(`/store-details?id=${promotion?.storeId}`)}
          >
            Vai al Negozio
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ActivePromotionCard;